import { useEffect, useState } from "react";
import { authApi } from "../api/auth";
import { loginEvent, createAccountEvent } from "../components/mixPanelEvents/mixPanelEvents";
import { generateRandomPassword } from "../helpers/utils";

interface UsePostPurchaseReturn {
    isProcessing: boolean;
}

export const usePostPurchase = (email: string, isPostPurchase: boolean): UsePostPurchaseReturn => {
    const [userExists, setUserExists] = useState<boolean | null>(null);
    const [isProcessing, setIsProcessing] = useState(false);

    // Check if user already exists
    useEffect(() => {
        if (!isPostPurchase || !email) return;

        const checkUser = async () => {
            try {
                const response = await authApi.checkAuthStatus();
                setUserExists(response.data.logged_in);
            } catch {
                setUserExists(false);
            }
        };

        checkUser();
    }, [isPostPurchase, email]);

    // Auto-create account if user doesn't exist
    useEffect(() => {
        if (!isPostPurchase || !email || userExists !== false) return;

        const createAccount = async () => {
            setIsProcessing(true);
            const password = generateRandomPassword();

            try {
                const response = await authApi.createAccountPostPurchase(email, password);

                if (response.data.success) {
                    createAccountEvent(email);
                    loginEvent();
                    window.location.href = window.location.origin;
                } else {
                    setIsProcessing(false);
                }
            } catch {
                setIsProcessing(false);
            }
        };

        createAccount();
    }, [isPostPurchase, email, userExists]);

    const shouldShowProcessing = isPostPurchase && email && (userExists === false || isProcessing);

    return { isProcessing: !!shouldShowProcessing };
};
